import { css, styled, Paper } from '@mui/material';

export const promotionCarouselSliderHeight = {
  desktop: '18.75rem',
  mobile: '13.75rem',
};

export const StyledPromotionCarouselPaper = styled(Paper)`
  padding: 0;
`;

export const StyledPromotionCarouselSlider = styled('div')(() => css``);

export const StyledCarouselControls = styled('div')(
  ({ theme }) => css`
    border-top: 1px solid ${theme.palette.gray.light_gray};
    padding: ${theme.spacing('LARGE')};
  `
);
